import React from "react";

export default function ExitCircleIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2493 9.75008L9.74935 16.2501M9.74935 9.75008L16.2493 16.2501M23.8327 13.0001C23.8327 18.9832 18.9824 23.8334 12.9993 23.8334C7.01626 23.8334 2.16602 18.9832 2.16602 13.0001C2.16602 7.017 7.01626 2.16675 12.9993 2.16675C18.9824 2.16675 23.8327 7.017 23.8327 13.0001Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
